import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { updateDb } from "../services/updateDb";

import {  useNavigate } from "react-router-dom";

const CoPilotForm = ({ copilotData, copilotId}) => {
    const navigate = useNavigate();
    const submitForm = async (e) => {
        e.preventDefault();
    
        const formData = new FormData(e.target);

        let copilotObj = {
            description: formData.get('description'),
            descriptionNL: formData.get('descriptionNL'),
            prompt: formData.get('prompt'),
            icon: formData.get('icon'),
            data: formData.get('data'),
            enabled: formData.get('enabled') === "true" ? true : false,
            category: formData.get('category'),
            categoryNL: formData.get('categoryNL'),
            shortTitle: formData.get('shortTitle'),
            shortTitleNL: formData.get('shortTitleNL'),
        };

        if(copilotData) {
            const res = await updateDb("/api/copilot/update/" + copilotId, copilotObj);

            if (res.success) 
                navigate("/copilotmanagement", { state: { message: "Copilot question successfully updated.", type: "warning" } });
        }
        else {
            const res = await updateDb("/api/copilot/", copilotObj);

            if (res.success) 
                navigate("/copilotmanagement", { state: { message: "Copilot question successfully added.", type: "success" } });
        }
    };

    return (
    <Form onSubmit={submitForm} id="copilotForm">

        <Row className="mb-3">
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Copilot question description</span></Form.Label>
                <Form.Control as="textarea" rows={3} name="description" placeholder="What do you want to display as copilot question?" defaultValue={copilotData ? copilotData.description : ""} required />
            </Form.Group>
        </Row>

        <Row className="mb-3">
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Copilot question description - Dutch 🇳🇱</span></Form.Label>
                <Form.Control as="textarea" rows={3} name="descriptionNL" placeholder="What do you want to display as copilot question, in Dutch?" defaultValue={copilotData ? copilotData.descriptionNL : ""} required />
            </Form.Group>
        </Row>

        <Row className="mb-3">
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Category</span></Form.Label>
                <Form.Control as="input" name="category" placeholder="e.g. Risk Discovery, Compliance, Trends" defaultValue={copilotData ? copilotData.category : ""} />
            </Form.Group>
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Category - Dutch 🇳🇱</span></Form.Label>
                <Form.Control as="input" name="categoryNL" placeholder="e.g. Risico Ontdekking, Compliance, Trends" defaultValue={copilotData ? copilotData.categoryNL : ""} />
            </Form.Group>
        </Row>

        <Row className="mb-3">
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Short Title</span></Form.Label>
                <Form.Control as="input" name="shortTitle" placeholder="e.g. Find Missing Risks" defaultValue={copilotData ? copilotData.shortTitle : ""} />
            </Form.Group>
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Short Title - Dutch 🇳🇱</span></Form.Label>
                <Form.Control as="input" name="shortTitleNL" placeholder="e.g. Vind Ontbrekende Risico's" defaultValue={copilotData ? copilotData.shortTitleNL : ""} />
            </Form.Group>
        </Row>

        <Row className="mb-3">
            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Copilot question prompt</span></Form.Label>
                <Form.Control as="textarea" rows={8} name="prompt" placeholder="What is the prompt sent to GPT for your question, be very specific and give thorough instructions." defaultValue={copilotData ? copilotData.prompt : ""} required />
            </Form.Group>
        </Row>

        <Row className="mb-3">
            <Form.Group as={Col}  >
                <Form.Label><span className="blue-bg">Attached data</span></Form.Label>
                <Form.Select name="data" defaultValue={copilotData?.data}>
                    <option value="">Select data to attach</option>
                    <option value="risks">Risks</option>
                    <option value="measures">Measures</option>
                    <option value="trends">Trends</option>
                    <option value="all">All data (risks, measures, history & trends)</option>
                </Form.Select>
            </Form.Group>

            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Icon name</span></Form.Label>
                <Form.Control as="input" name="icon" defaultValue={copilotData ? copilotData.icon : ""} placeholder="What's the icon classname?" />
            </Form.Group>

            <Form.Group as={Col} >
                <Form.Label><span className="blue-bg">Visibility</span></Form.Label>
                <Form.Select name="enabled" defaultValue={copilotData?.enabled} required>
                    <option value="">Select status</option>
                    <option value="true">Enabled</option>
                    <option value="false">Disabled</option>
                </Form.Select>
            </Form.Group>
        </Row>

        <div className="vertical-spacer" />

        <input className="white-border-btn submit-btn" type="submit" value={(copilotData ? "Update" : "Add") + " Question"} />
            
    </Form>
);
};
export default CoPilotForm;
